module.exports = __webpack_public_path__ + "static/img/14.5c1c16f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/sp/14.png
// module id = UEqZ
// module chunks = 0